import(/* webpackMode: "eager", webpackExports: ["UserLayout"] */ "/vercel/path0/frontend_next/src/components/layout/UserLayout.tsx");
